import { Box } from "@mui/material";

import { useSelector } from "react-redux";
import { themesSelector } from "theme/selector";

import { Outlet, useLocation } from "react-router-dom";
import { Suspense } from "react";
import LoadingIcon from "components/common/LoadingIcon";
import HiddenButtonHeader from "./Component/hiddenButtonHeader";
import pathRoutes from "routes/pathRoutes";

const HeaderLayout = () => {
  const { isMiniSidenav } = useSelector(themesSelector);
  const location = useLocation();
  return (
    <Box
      sx={({ palette, functions: { pxToRem } }) => ({
        height:
          location.pathname === pathRoutes.extra.mbsBirthday26
            ? 0
            : pxToRem(72),
        backgroundColor: palette.background.bgPrimary,
        width: {
          xs: "100%",
          xl: isMiniSidenav
            ? `calc(100% - ${pxToRem(100)})`
            : `calc(100% - ${pxToRem(304)})`,
        },
        transition: "width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.05)",
      })}
      display="flex"
      justifyContent="space-between"
      alignItems={"center"}
      position="fixed"
      top={0}
      zIndex={1000}
      overflow={"auto"}
    >
      {/* <MiniaturizationButtonHeader /> */}
      <Suspense fallback={<LoadingIcon />}>
        <Outlet />
      </Suspense>
      <HiddenButtonHeader />
    </Box>
  );
};

export default HeaderLayout;
